<template>
    <div class="compare__programs" :class="{ 'loading': loading }">
        <div v-if="loading && comparePrograms.length < 1">
            <div class="loading__container"></div>
        </div>

        <div v-else-if="compareList.length === 0" class="my-dashboard__empty">
            <h3 class="step--4 black-primary margin--xs-s">
                {{ printString("your_list_is_empty") }}
            </h3>
            <p class="paragraph--teaser margin--s-m">
                {{ printString("add_programs_to_compare_list") }}
            </p>
            <button class="general-button orange-background"
                @click.prevent="goBackToPrograms"
                @keydown.enter.prevent="goBackToPrograms"
                
            >
                {{ printString("find_programs") }}
            </button>
        </div>
        <div v-else class="compare__programs__list compare__list" :class="{ 'loading': loading }">

            <div class="compare__programs__line compare__list__line">

                <p class="paragraph--teaser">
                    {{ printString('compare_up_to_3_programs') }}
                </p>

                <div v-for="program in dataProgramGeneral" :key="program.id" class="compare__programs__item compare__item">
                    <a class="compare__item__link" :href="`${programUrl}${program.id}/`" 
                        @click.prevent="goToProgramPage(program.id)"
                        @keydown.enter.prevent="goToProgramPage(program.id)"
                        
                    >
                        <figure class="margin--xs-s">
                            <img :src="program.university_img.src" :alt="program.university_img.title" width="100"/>
                        </figure>
                        <h2 class="step--2 margin--xs-s">{{ program.program_name }}</h2>
                        
                    </a>
                    <a :href="program.program_url" class="secondary-button red-color" v-if="program.program_url" target="_blank">
                        {{ printString('program_website') }}
                        <span v-html="ico_external_16"/>
                    </a>
                    <button 
                        @click="handleAddToCompare(program.id)"
                        class="general-button border-grey only-icon"
                    >
                        <span v-html="ico_close_16"/>
                        <span class="vh">{{ printString('remove') }}</span>
                    </button>
                </div>

            </div>

            <div class="compare__programs__line compare__list__line" v-if="dataUniversitiesNames.length > 0">
                <p class="step--1 black-primary">
                    {{ printString('university') }}
                </p>
                <div    class="compare__programs__item compare__item"
                        v-for="university in dataUniversitiesNames"
                        :key="university"
                >
                    <p>
                        {{ university }}
                    </p>
                </div>
            </div>

            <div class="compare__programs__line compare__list__line" v-if="dataDepartment.length > 0">
                <p class="step--1 black-primary">
                    {{ printString('department') }}
                </p>
                <div    class="compare__programs__item compare__item"
                        v-for="department in dataDepartment"
                        :key="department"
                >
                    <p>
                        {{ department }}
                    </p>
                </div>
            </div>

            <div class="compare__programs__line compare__list__line" v-if="dataLevel.length > 0">
                <p class="step--1 black-primary">
                    {{ printString('level') }}
                </p>
                <div    class="compare__programs__item compare__item"
                        v-for="level in dataLevel"
                        :key="level"
                >
                    <p>
                        {{ level }}
                    </p>
                </div>
            </div>

            <div class="compare__programs__line compare__list__line" v-if="dataLanguage.length > 0">
                <p class="step--1 black-primary">
                    {{ printString('language') }}
                </p>
                <div    class="compare__programs__item compare__item"
                        v-for="language in dataLanguage"
                        :key="language"
                >
                    <p v-if="language == 'fr'">
                        {{ printString('french') }}
                    </p>
                    <p v-else-if="language == 'en'">
                        {{ printString('english') }}
                    </p>
                </div>
            </div>

            <div class="compare__programs__line compare__list__line" v-if="dataAreaOfStudy.length > 0">
                <p class="step--1 black-primary">
                    {{ printString('area_of_study') }}
                </p>
                <div    class="compare__programs__item compare__item"
                        v-for="area in dataAreaOfStudy"
                        :key="area"
                >
                    <p>
                        {{ area }}
                    </p>
                </div>
            </div>

            <div class="compare__programs__line compare__list__line" v-if="dataCoop.length > 0">
                <p class="step--1 black-primary">
                    {{ printString('co_op_availability') }}
                </p>
                <div    class="compare__programs__item compare__item"
                        v-for="coop in dataCoop"
                        :key="coop"
                >
                    <p v-if="coop == '0'">
                        {{ printString('no') }}
                    </p>
                    <p v-else-if="coop == '1'">
                        {{ printString('yes') }}
                    </p>
                </div>
            </div>

            <div class="compare__programs__line compare__list__line" v-if="dataRemote.length > 0">
                <p class="step--1 black-primary">
                    {{ printString('remote_learning') }}
                </p>
                <div    class="compare__programs__item compare__item"
                        v-for="remote in dataRemote"
                        :key="remote"
                >
                    <p v-if="remote == '0'">
                        {{ printString('no') }}
                    </p>
                </div>
            </div>

            <div class="compare__programs__line compare__list__line" v-if="dataDescription.length > 0">
                <p class="step--1 black-primary">
                    {{ printString('description') }}
                </p>
                <div    class="compare__programs__item compare__item"
                        v-for="description in dataDescription"
                        :key="description"
                >
                    <p v-html="description"></p>
                </div>
            </div>


        </div>

        <div class="loader" v-if="comparePrograms.length > 0"></div>
    </div>
</template>

<script>

import { useRoute, useRouter } from 'vue-router';

export default {
    name: 'ComparePrograms',
    data() {
        return {
            comparePrograms: [],
            loading: true,
            compareList: [],
            ico_close_16: window.ico_close_16,
            ico_external_16: window.ico_external_16,
            activeRequests: 0,
            programUrl: window.program_url,
        };
    },
    created() {
        this.route = useRoute();
        this.router = useRouter();
        this.loadComparePrograms();
    },
    computed: {
        dataUniversitiesNames() {
            const names = this.comparePrograms.map(program => program.university[0].name);
            return names.every(name => name === null) ? [] : names;
        },
        dataDepartment() {
            const departments = this.comparePrograms.map(program => program.program[0].faculty_name);
            return departments.every(department => department === null) ? [] : departments;
        },
        dataLevel() {
            const levels = this.comparePrograms.map(program => program.program[0].program_level_description);
            return levels.every(level => level === null) ? [] : levels;
        },
        dataLanguage() {
            const languages = this.comparePrograms.map(program => program.program[0].program_language);
            return languages.every(language => language === null) ? [] : languages;
        },
        dataAreaOfStudy() {
            const areas = this.comparePrograms.map(program => program.program[0].area_of_study);
            return areas.every(area => area === null) ? [] : areas;
        },
        dataCoop() {
            const coops = this.comparePrograms.map(program => program.program[0].coop_available);
            return coops.every(coop => coop === null) ? [] : coops;
        },
        dataRemote() {
            const remotes = this.comparePrograms.map(program => program.program[0].distance_education_available);
            return remotes.every(remote => remote === null) ? [] : remotes;
        },
        dataDescription() {
            const descriptions = this.comparePrograms.map(program => program.program[0].program_description);
            return descriptions.every(description => description === null) ? [] : descriptions;
        },
        dataProgramGeneral() {
            return this.comparePrograms.map(program => ({
                university_img: program.university[0].university_logo,
                program_name: program.program[0].program_name,
                id: program.program[0].id,
                program_url: program.program[0].program_url
            }));
        }
    },
    methods: {
        goToProgramPage(programId) {
            // const routeName = window.lang === 'fr' ? 'programSingleFr' : 'programSingle';
            const routeName = window.lang === 'fr' ? 'programSingle' : 'programSingle';
            this.$router.push({ name: routeName, params: { id: programId } });
        },
        startLoading() {
            this.activeRequests++;
            this.loading = true;

            console.log('startLoading active requests', this.activeRequests);
        },
        finishLoading() {
            this.activeRequests--;
            if (this.activeRequests === 0) {
                this.loading = false;
            }
            console.log('finishLoading active requests', this.activeRequests);
        },
        goBackToPrograms() {
            // const route = this.site_lang === 'fr' ? '/fr/programs' : '/programs';
            const route = this.site_lang === 'fr' ? '/programs' : '/programs';
            this.router.push({ path: route });
        },
        loadComparePrograms() {
            const storedList = localStorage.getItem('compareListPrograms');
            if (storedList) {
                
                this.compareList = JSON.parse(storedList);
                if(this.compareList.length > 0) {
                    this.fetchProgramDetails(this.compareList);
                } else {
                    this.comparePrograms = [];
                    this.loading = false;
                }
            } else {
                this.compareList = [];
                this.loading = false;
            }
        },
        saveCompareListToStorage() {
            localStorage.setItem('compareListPrograms', JSON.stringify(this.compareList));
            console.log('Compare list saved to local storage:', this.compareList);
        },
        async fetchProgramDetails(programIds) {
            this.startLoading();
            try {
                const apikey = window.api_key;
                const requests = programIds.map(id => 
                fetch(`${window.api_base_url}/api/programs-single/`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        apikey: apikey,
                        site_lang: window.lang,
                        program_id: id,
                    }),
                }).then(response => response.json())
                );

                const results = await Promise.all(requests);
                this.comparePrograms = results;
            } catch (error) {
                console.error("Error fetching program details:", error);
            } finally {
                this.finishLoading();
            }
        },
        async handleAddToCompare(programId) {
            this.startLoading();
            try {
                const index = this.compareList.indexOf(programId);
                
                if (index !== -1) {
                    this.compareList.splice(index, 1);
                    console.log(`Program removed from compare list: ${programId}`);
                } else {
                    console.warn(`Program not found in compare list: ${programId}`);
                }

                this.saveCompareListToStorage();

                if(this.compareList.length > 0) {
                    await this.fetchProgramDetails(this.compareList);
                } else {
                    this.comparePrograms = [];
                    this.loading = false;
                }
            } catch (error) {
                console.error("Error in compare operation:", error);
            } finally {
                this.finishLoading();
            }
        },

        printString(string) {
            return window.translations[string] || string;
        },
    },

};
</script>

